import React from 'react'

import back from './../../../UI/canvas/CarMenu/btns/back-btn.svg'
import close from './../../../UI/canvas/CarMenu/btns/Close.svg'

import { modelsData } from '../../../data/models.data'

interface Props {
  isThreeActive: boolean,
  handleSelectedMenuElement: any,
  handleSetAccessoriesSelected: any,
  currentAccessoriesSelected: any,
  handleSetColor: any,
  handleSetOpenModule: any
  handleOpenTerms: any,
  carSelected: string
}

interface State {
  isOpened: boolean,
  selectedCar: string,
  currentColorIndexSelected: number,
  currentAccessoriesSet: any
}

class AccessoriesModuleMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      isOpened: true,
      selectedCar: "",
      currentColorIndexSelected: 0,
      currentAccessoriesSet: {}
    }
  }

  componentDidMount(): void {
    let accessoriesObject = {}
    let initalAccesoriosSelected: any = []
    let accessories = {}

    this.setState({
      selectedCar: this.props.carSelected
    }, () => {
      modelsData()[0][this.state.selectedCar].accesories.map((accessory: any) => {
        accessories[accessory.name] = accessory.name.includes('BDM') ? 1:0
        if(accessoriesObject.hasOwnProperty(accessory.section)){
          accessoriesObject[accessory.section].push(accessory)
        }
        else {
          accessoriesObject[accessory.section] = [accessory]
        }
        return 0
      })
  
      this.setState({
        currentAccessoriesSet: accessoriesObject
      }, () => {
        this.props.handleSetAccessoriesSelected(accessories, '')
        this.props.handleSetColor(modelsData()[0][this.state.selectedCar].colors[0])
      })
  
    })
  }

  handleAddAccessorie = (accessory) => {
    let tempAccessories =  this.props.currentAccessoriesSelected
    tempAccessories[accessory.name] = tempAccessories[accessory.name] === 1 ? 0:1
    if(tempAccessories[accessory.name] === 0){
      if(accessory.enableOnDisable){
        accessory.enableOnDisable.map((accesoryToShow: any) => {
          tempAccessories[accesoryToShow] = 1
          return 0
        }) 
      }
    }
    if(accessory.hide && tempAccessories[accessory.name] === 1){
      accessory.hide.map((hiddenAccessory: any) => {
        tempAccessories[hiddenAccessory] = 0
        return 0
      })
    }
    this.props.handleSetAccessoriesSelected(tempAccessories, accessory)
  }

  handleChangeColor = (color: any, index: number) => {
    this.setState({
      currentColorIndexSelected: index
    }, () => {
      this.props.handleSetColor(color)
    })
  }

  render(): React.ReactNode {
      return(
        this.state.selectedCar !== '' ?
        <div className='accessories-module-container-mobile'>
          <div className='open-close-accessories-mobile' onClick={() => {
            this.props.handleSetOpenModule()
            this.setState({isOpened: !this.state.isOpened})
            }}>
            <div>Personaliza tu Ford</div>
            <img src={back} alt='' className={this.state.isOpened ? 'opened-modal':'closed-modal'}/>
          </div>
          {this.state.isOpened ?
             <div className={this.state.isOpened ? 'opened-accessories-modal':'closed-accessories-modal'}>
             <div className='accesories-colors-container-mobile'>
               <div className='accessories-colors-title-mobile'>Color</div>
               <div className='accessories-colors-btns-container-mobile'>
                 {
                   modelsData()[0][this.state.selectedCar].colors.map((color: any, index: number) => 
                     <div className={this.state.currentColorIndexSelected === index ? 'accessories-color-btn-selected-mobile':'accessories-color-btn-mobile'} id='element-umbra-analytics' data-second={color.Name} data-value={this.state.selectedCar} data-type={"COLOR"} onClick={() => {
                      this.handleChangeColor(color, index)
                    }}>
                       <img id='element-umbra-analytics' data-second={color.Name} data-value={this.state.selectedCar} data-type={"COLOR"} src={color.Image} alt=""/>
                     </div>
                   )
                 }
               </div>
               <div className='accessories-current-color-name-mobile'>{modelsData()[0][this.state.selectedCar].colors[this.state.currentColorIndexSelected].Name}</div>
             </div>
             <div className='accesories-categoty-container-mobile'>
               {
                 Object.keys(this.state.currentAccessoriesSet).map((category: any, index: number) => 
                 {
                   let currentAccessoriesSelected: Array<string> = []
                   this.state.currentAccessoriesSet[category].map((model: any) => 
                   {
                     if( this.props.currentAccessoriesSelected[model.name] === 1){
                       currentAccessoriesSelected.push(model.showroom)
                     }
                     return 0
                   }
                   )

                   return(
                     <div className='accessories-category-individual-container-mobile' key={category+index}>
                       <div className='accessories-category-inidivual-title-mobile'>
                        {category}
                       </div>
                       <div className='accessorioes-category-thumbs-container-mobile'>
                         {
                           this.state.currentAccessoriesSet[category].map((model: any, index: any) => 
                           !model.name.includes('BDM') ?
                             <div className={this.props.currentAccessoriesSelected[model.name] === 1 ? 'accessories-thumb-selected-mobile':'accessories-thumb-mobile'} onClick={() => {this.handleAddAccessorie(model)}}>
                               <img src={model.Image} alt="" className='accessories-current-thumb'/>
                               <div className='accessories-complete-name-mobile'>
                                {
                                  model.showroom
                                }
                              </div>
                              {
                                this.props.currentAccessoriesSelected[model.name] === 1 ?
                                <div className='delete-btn-accessories-mobile'>
                                  <img src={close} alt=''/>
                                </div>:null
                              }
                             </div>:null
                           )
                         }
                       </div>
                     </div>
                   )
                 }
                 )
               }
             </div>
           </div>:null
          }
        </div>:null
      )
  }
}

export default AccessoriesModuleMobile